import * as React from "react";
import { useContext, useReducer } from "react";
import { ChatStates } from "../Interfaces/Stores/IHostStore";
import sortHosts from "../Helper/HostListSorter";
var initialState = {
  hosts: sortHosts(window.initData),
  registered: [],
  selected: null,
  page: 0,
  chat: {
    started: 0,
    chatId: '',
    userId: '',
    screenName: '',
    clientId: '',
    server: '',
    client: '',
    running: ChatStates.NO
  }
};
export var HostContext = /*#__PURE__*/React.createContext(null);
export var HostProvider = function (_a) {
  var reducer = _a.reducer,
    children = _a.children;
  return /*#__PURE__*/React.createElement(HostContext.Provider, {
    value: useReducer(reducer, initialState)
  }, children);
};
export var useHostValue = function () {
  return useContext(HostContext);
};